<script>
import Multiselect from "@vueform/multiselect";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import useVuelidate from "@vuelidate/core";
import {helpers, required} from "@vuelidate/validators";
import Swal from "sweetalert2";
import Loader from "../components/loader";
import api from "@/axios";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {
  page: {
    title: "Editar Categorias",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Loader, Multiselect },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      loadingCategoria: false,
      errosValid: null,
      categoriaData: {
        id: 0,
        status: 'A',
        tipo: 'EN',
        parent_id: null,
      },
      idData: 0,
      updating: true,
      submitted: false,

      isSubcategoria: false,
      categoriasPaiList: [],
      loadingCategoriasPai: false,

      title: "Editar Categorias",
      items: [
        {
          text: "Categorias",
          href: "/categorias/list",
        },
        {
          text: "Editar Categorias",
          active: true,
        },
      ],

      showHierarchyModal: false,

    };
  },
  watch: {
    'categoriaData.parent_id'(newVal) {
      if (newVal && this.isSubcategoria) {
        const parent = this.originalCatsList.find(c => c.id === newVal);
        if (parent) {
          this.categoriaData.tipo = parent.tipo;
        }
      }
    }
  },
  validations() {
    return {
      categoriaData: {
        descricao: {
          required: helpers.withMessage("Campo descrição obrigatório, favor preencher.", required),
        },
        codigo: {
          required: helpers.withMessage("Campo código obrigatório, favor preencher.", required),
        },
        tipo: {
          required: helpers.withMessage("Campo Tipo obrigatório, favor preencher.", required),
        },
        parent_id: {
          required: helpers.withMessage("Para subcategorias, selecione a categoria pai.", (val) => {
            if (this.isSubcategoria) {
              return !!val;
            }
            return true;
          }),
        },
      },
    };
  },
  methods: {

    async carregarDados(){
      console.log('mounted_categorias_editar_0')
      let rota = this.$route.path
      let ultimaBarra = rota.lastIndexOf('/')
      if (ultimaBarra){
        this.idData = parseInt(rota.substring(ultimaBarra + 1))
      }
      console.log(`idData: ${this.idData}`)

      await this.carregarCategoriasPai();

      if (this.idData > 0){
        api.get(`${getBaseUrl()}api/categoria`, {
          params: { iddata: this.idData }
        }).then((res) => {
          console.log('then axios mounted')
          console.log(res.data)
          this.categoriaData = res.data[0]

          if (this.categoriaData.ori === null){
            this.categoriaData.ori = '0'
          }

          if (this.categoriaData.parent_id) {
            this.isSubcategoria = true;
          }

          this.idData = this.categoriaData.id
          this.title = `Editar Categorias (${this.categoriaData.id}) ${this.categoriaData.descricao}`
          this.updating = false
        });
      }else{
        this.title = `Criando Nova Categorias`
        this.updating = false
        this.showHierarchyModal = true
      }
    },

    async carregarCategoriasPai() {
      this.loadingCategoriasPai = true;
      try {
        const res = await api.get(`${getBaseUrl()}api/categorias`, {
          params: { s: 'A' }
        });
        const allCats = res.data[0] || [];
        this.originalCatsList = allCats;
        this.categoriasPaiList = allCats
            .filter(cat => cat.id !== this.idData)
            .map(cat => ({
              value: cat.id,
              label: `${cat.codigo} - ${cat.descricao}`
            }));
      } catch (error) {
        console.error("Erro ao carregar categorias pai:", error);
      } finally {
        this.loadingCategoriasPai = false;
      }
    },

    toggleSubcategoria() {
      if (!this.isSubcategoria) {
        this.categoriaData.parent_id = null;
      }
    },

    unlinkParent() {
      this.categoriaData.parent_id = null;
    },

    formatDecimal(value) {
      if (value) {
        let value_n = parseFloat(value);
        return value_n.toLocaleString("pt-BR", {
          style: "decimal",
          minimumFractionDigits: 4,
        });
      }
      return "0,00";
    },

    /*pesqCFOP(evt){
      console.log('pesqCFOP')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        this.dtListPesqCFOP = null
        this.loadingCFOPs = true
        api.get(`${getBaseUrl()}api/pesqcfops`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqCFOP = res.data
        })
      }
    },*/

    /*pesqProduto(tipo, evt){
      console.log('pesqProduto')
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        console.log(evt)

        this.loadingCFOPs = true
        api.get(`${getBaseUrl()}api/prodpesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)

          switch(tipo){
            case 'icms':
              console.log(`tipo selected ${tipo}`)
              this.dtListPesqProdutoIcms = res.data
              break
            case 'ipi':
              console.log(`tipo selected ${tipo}`)
              this.dtListPesqProdutoIpi = res.data
              break
            case 'pis':
              console.log(`tipo selected ${tipo}`)
              this.dtListPesqProdutoPis = res.data
              break
            case 'cofins':
              console.log(`tipo selected ${tipo}`)
              this.dtListPesqProdutoCofins = res.data
              break
            default:
              console.log(`tipo selected ${tipo}`)
              this.dtListPesqProduto = res.data
              break
          }
        })
      }
    },*/


    salvar() {
      this.submitted = true;
      this.v$.$touch();
      console.log('salvarCategoria');
      console.log(this.categoriaData);

      if (this.v$.$invalid) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Favor preencher todos os campos obrigatórios antes de salvar.",
          showConfirmButton: false,
          timer: 1500
        });
        return;
      }

      console.log('salvarCategoria_00');
      this.updating = true;
      this.errosValid = [];

      api.post(`${getBaseUrl()}api/categoria`, {
        categoriaData: this.categoriaData
      }).then((res) => {
        console.log('then axios');
        console.log(res);

        if (res.data.success) {
          this.categoriaData = res.data.categoriaFin;
          this.updating = false;

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            this.$router.push({ path: `/categorias/list` });
          });
        } else {
          this.updating = false;
          Swal.fire({
            icon: "error",
            title: "Erro ao salvar",
            text: res.data.message || "Erro desconhecido ao salvar.",
            showConfirmButton: false,
            timer: 2500
          });
        }

      }).catch((err) => {
        console.log('erro axios');
        this.updating = false;

        let errorMessage = "Ocorreu um erro ao processar a requisição.";
        if (err.response && err.response.data && err.response.data.message) {
          errorMessage = err.response.data.message;
        }

        Swal.fire({
          icon: "error",
          title: "Erro ao salvar",
          text: errorMessage,
          showConfirmButton: false,
          timer: 2500
        });
      });
    },

    voltaralista(){
      this.$router.replace({ path: `/categorias/list` })
    }
  },
  mounted() {
    this.carregarDados()
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <div class="checkout-tabs" v-if="!updating">

        <div class="card">
          <div class="card-body">

            <div class="d-flex align-items-start mb-2">
              <b-button variant="success" class="mx-2" @click="salvar">
                <i class="bx bx-save font-size-16 align-middle me-2"></i>
                Salvar Alterações
              </b-button>

              <b-button variant="primary" class="ms-auto" @click="voltaralista">
                <i class="mdi mdi-arrow-left font-size-16 align-middle me-2"></i>
                Voltar para a lista
              </b-button>
            </div>

            <hr class="mb-5">

            <form class="needs-validation mb-4">
              <div class="row align-items-center bg-light p-3 rounded mb-4 shadow-sm mx-0">
                <div class="col-sm-3">
                  <div class="mb-0">
                    <h5 class="font-size-14 mb-2">Tipo de categoria:</h5>
                    <b-form-checkbox
                        switch size="lg"
                        v-model="isSubcategoria"
                        @change="toggleSubcategoria"
                        class="custom-switch-blue">
                      {{ isSubcategoria ? 'Subcategoria' : 'Categoria Raiz' }}
                    </b-form-checkbox>
                  </div>
                </div>

                <div class="col-md-7" v-if="isSubcategoria">
                  <label class="fw-bold">Categoria Pai <span class="text-danger">*</span></label>
                  <div class="d-flex gap-2">
                    <div class="flex-grow-1">
                      <Multiselect
                          v-model="categoriaData.parent_id"
                          :options="categoriasPaiList"
                          :searchable="true"
                          :loading="loadingCategoriasPai"
                          placeholder="Selecione a categoria pai"
                          noOptionsText="Nenhuma categoria encontrada"
                          noResultsText="Nenhum resultado encontrado"
                          :class="{'is-invalid-multiselect': submitted && v$.categoriaData.parent_id.$error}"
                      />
                      <div v-if="submitted && v$.categoriaData.parent_id.$error" class="text-danger font-size-12 mt-1">
                        {{ v$.categoriaData.parent_id.required.$message }}
                      </div>
                    </div>
                    <div class="d-flex align-items-center">
                      <i
                          :class="[
                            'mdi',
                            categoriaData.parent_id ? 'mdi-link-variant-off text-danger' : 'mdi-link-variant text-success',
                            'font-size-24 cursor-pointer'
                          ]"
                          @click="categoriaData.parent_id ? unlinkParent() : null"
                          :style="{ opacity: (!categoriaData.parent_id && isSubcategoria) ? '0.5' : '1' }"
                          v-b-tooltip.hover
                          :title="categoriaData.parent_id ? 'Desvincular' : 'Vincular'"
                      ></i>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="descricao">Descrição</label>
                    <input
                        id="descricao"
                        v-model="categoriaData.descricao"
                        type="text"
                        class="form-control"
                        placeholder="Descrição"
                        maxlength="60"
                        :class="{'is-invalid': submitted && v$.categoriaData.descricao.$error,}"/>
                    <div v-if="submitted && v$.categoriaData.descricao.$error"
                         class="invalid-feedback">
                      <span v-if="v$.categoriaData.descricao.required.$message">{{ v$.categoriaData.descricao.required.$message }}</span>
                    </div>
                  </div>
                </div>


                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="codigo">Código</label>
                    <input
                        id="codigo"
                        v-model="categoriaData.codigo"
                        type="text"
                        class="form-control"
                        placeholder="Código"
                        :class="{'is-invalid': submitted && v$.categoriaData.codigo.$error,}"/>
                    <div v-if="submitted && v$.categoriaData.codigo.$error" class="invalid-feedback">
                      <span v-if="v$.categoriaData.codigo.required.$message">{{ v$.categoriaData.codigo.required.$message }}</span>
                    </div>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="tipo">Tipo</label>
                    <select
                        id="tipo"
                        v-model="categoriaData.tipo"
                        class="form-control"
                        :disabled="!!categoriaData.parent_id"
                        :class="{'is-invalid': submitted && v$.categoriaData.tipo.$error,}">
                      <option value="EN">Receita</option>
                      <option value="SA">Despesa</option>
                    </select>
                    <div v-if="submitted && v$.categoriaData.tipo.$error" class="invalid-feedback">
                      <span v-if="v$.categoriaData.tipo.required.$message">{{ v$.categoriaData.tipo.required.$message }}</span>
                    </div>
                  </div>
                </div>

                <div class="col-sm-2">
                  <div class="mb-3">
                    <h5 class="font-size-14 mt-1 mb-2">Status</h5>
                    <b-form-checkbox
                        switch size="lg"
                        value="A"
                        unchecked-value="I"
                        v-model="categoriaData.status"
                        class="custom-switch-green">
                      {{ categoriaData.status === 'A' ? 'Ativo' : 'Inativo' }}
                    </b-form-checkbox>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="livre1">Observação 1</label>
                    <textarea
                        id="livre1"
                        v-model="categoriaData.livre1"
                        type="text"
                        rows="1"
                        class="form-control"
                        placeholder="Observação"/>
                  </div>
                </div>
              </div>


              <div class="row">
                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="livre2">Observação 2</label>
                    <textarea
                        id="livre2"
                        v-model="categoriaData.livre2"
                        type="text"
                        rows="3"
                        class="form-control"
                        placeholder="Observação Adicional"/>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="livre3">Observação 3</label>
                    <textarea
                        id="livre3"
                        v-model="categoriaData.livre3"
                        type="text"
                        rows="3"
                        class="form-control"
                        placeholder="Observação Adicional"/>
                  </div>
                </div>

              </div>
            </form>

          </div>
        </div>
    </div>


    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>

    <b-modal
        id="modal-hierarquia"
        v-model="showHierarchyModal"
        hide-footer
        centered
        size="lg"
        header-class="border-0 pb-0"
        no-close-on-backdrop
        no-close-on-esc
        hide-header-close
    >
      <div class="text-center p-4">
        <div class="mb-4">
          <h4 class="fw-bold">Olá!</h4>
          <p class="text-muted font-size-15">
            A categoria que você está configurando é uma <span class="fw-bold text-primary">Subcategoria</span> ou uma <span class="fw-bold text-success">Categoria Raiz</span>?
          </p>
        </div>

        <div class="row g-4 mb-4">
          <div class="col-sm-6">
            <div
                class="card border-2 cursor-pointer h-100 selection-card"
                :class="!isSubcategoria ? 'border-success bg-soft-success' : 'border-light'"
                @click="isSubcategoria = false; toggleSubcategoria()"
            >
              <div class="card-body p-4">
                <div class="mb-3">
                  <i :class="['mdi', !isSubcategoria ? 'mdi-check-circle text-success' : 'mdi-circle-outline text-light', 'font-size-24 float-end']"></i>
                  <i class="mdi mdi-file-tree font-size-40 text-success"></i>
                </div>
                <h5 class="fw-bold text-success mb-2">Categoria Raiz</h5>
                <p class="text-muted mb-0 font-size-13">Uma categoria principal que não possui dependências.</p>
              </div>
            </div>
          </div>

          <div class="col-sm-6">
            <div
                class="card border-2 cursor-pointer h-100 selection-card"
                :class="isSubcategoria ? 'border-primary bg-soft-primary' : 'border-light'"
                @click="isSubcategoria = true"
            >
              <div class="card-body p-4">
                <div class="mb-3">
                  <i :class="['mdi', isSubcategoria ? 'mdi-check-circle text-primary' : 'mdi-circle-outline text-light', 'font-size-24 float-end']"></i>
                  <i class="mdi mdi-file-tree-outline font-size-40 text-primary"></i>
                </div>
                <h5 class="fw-bold text-primary mb-2">Subcategoria</h5>
                <p class="text-muted mb-0 font-size-13">Uma categoria que pertence a um grupo ou categoria pai.</p>
              </div>
            </div>
          </div>
        </div>

        <transition name="fade">
          <div v-if="isSubcategoria" class="p-3 bg-light rounded shadow-sm mb-4">
            <label class="fw-bold d-block text-start mb-2">Selecione a Categoria Pai <span class="text-danger">*</span></label>
            <Multiselect
                v-model="categoriaData.parent_id"
                :options="categoriasPaiList"
                :searchable="true"
                :loading="loadingCategoriasPai"
                placeholder="Qual o pai desta subcategoria?"
                noOptionsText="Nenhuma categoria encontrada"
                noResultsText="Nenhum resultado encontrado"
            />
          </div>
        </transition>

        <div class="d-grid gap-2">
          <b-button
              variant="primary"
              size="lg"
              class="rounded-pill shadow"
              @click="showHierarchyModal = false"
              :disabled="isSubcategoria && !categoriaData.parent_id"
          >
            Confirmar Configuração <i class="mdi mdi-check-bold ms-1"></i>
          </b-button>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>

<style scoped>
.custom-switch-blue :deep(.form-check-input:checked) {
  background-color: #3498db;
  border-color: #3498db;
}

.custom-switch-green :deep(.form-check-input:checked) {
  background-color: #2ecc71;
  border-color: #2ecc71;
}

:deep(.is-invalid-multiselect) {
  --ms-border-color: #f46a6a;
}

.cursor-pointer {
  cursor: pointer;
}

.selection-card {
  transition: all 0.3s ease;
  transform: translateY(0);
}

.selection-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0,0,0,0.05) !important;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
